import React from 'react';
import { styled } from '@mui/material';

import { Button, Card, Icon, ProgressBar, Stack, Tag, Text } from 'shell/components';

const TeamCard = ({
    category,
    groupName,
    progress,
    status,
    suggestions,
    onClickViewAllByType,
    onClickViewGroupDetail,
}) => {
    if (!suggestions.length) return <></>;

    return (
        <CustomCard onClick={() => onClickViewGroupDetail()}>
            <Stack spacing={2}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'sh1'} weight={'semibold'}>
                        {groupName}
                    </Text>
                    <Tag type={'progress'} value={status} />
                </Stack>
                <Stack spacing={1}>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Text variant={'p2'}>Progress</Text>
                        <Text variant={'p2'}>{progress || 0}%</Text>
                    </Stack>
                    <ProgressBar value={Number(progress)} />
                </Stack>
                <CustomStack spacing={4}>
                    {suggestions.slice(0, 2).map((suggestion, index) => (
                        <Stack key={index} alignItems={'center'} direction={'row'} spacing={2}>
                            <CustomIcon kind={'error'} size={'xsmall'} variant={'circle'} />
                            <Text variant={'p2'}>{suggestion.text}</Text>
                        </Stack>
                    ))}
                </CustomStack>
                {suggestions.length > 2 && (
                    <CustomButton
                        variant={'tertiary'}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickViewAllByType(category);
                        }}
                    >
                        View all ({suggestions.length})
                    </CustomButton>
                )}
            </Stack>
        </CustomCard>
    );
};

const CustomCard = styled(Card)(() => {
    return {
        maxWidth: '325px',
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        borderRadius: '6px',
        padding: theme.spacing(3),
        background: theme.palette.ensightful.neutral[50],
    };
});

const CustomIcon = styled(Icon)(({ theme }) => {
    return {
        width: '1.5rem',
        height: '1.5rem',
        borderRadius: '50%',
        padding: '0.3125rem',
        background: theme.palette.ensightful.error[700],
        color: theme.palette.ensightful.shades[0],
        '&:hover': {
            background: theme.palette.ensightful.error[700],
        },
    };
});

const CustomButton = styled(Button)(() => {
    return {
        alignSelf: 'flex-end',
        width: 'fit-content',
    };
});

export default TeamCard;
